/**
 * BudgetReportService
 *
 * Saved Report Builder configurations — the RECIPE, not the output. Re-running a definition
 * regenerates the report against current data, which is why nothing rendered is stored: a
 * saved report that quietly served last month's numbers under this month's date would be
 * worse than no saved report at all.
 *
 * Rendering and export (CSV/XLSX/PDF/DOC) happen in the browser.
 *
 * Route: api/budget-reports
 */
export class BudgetReportService {
    constructor(http, config) {
        this.http = http;
        this.servicePath = config?.servicePath ?? BudgetReportService.DEFAULT_SERVICE_PATH;
    }
    buildUrl(path) {
        const base = `${this.servicePath}/api/budget-reports`;
        const url = path ? `${base}/${path}` : base;
        return url.startsWith('/') ? url : '/' + url;
    }
    /** Your reports, plus anything shared with everyone. */
    async getAll() {
        const response = await this.getAllRaw();
        return response.data ?? [];
    }
    getAllRaw() {
        return this.http.get(this.buildUrl());
    }
    async create(body) {
        const response = await this.createRaw(body);
        return response.data ?? null;
    }
    createRaw(body) {
        return this.http.post(this.buildUrl(), body);
    }
    /** Only the owner may change a report — "shared" means readable, not rewritable. */
    async update(reportId, body) {
        const response = await this.updateRaw(reportId, body);
        return response.data ?? null;
    }
    updateRaw(reportId, body) {
        return this.http.put(this.buildUrl(String(reportId)), body);
    }
    async delete(reportId) {
        const response = await this.deleteRaw(reportId);
        return response.data ?? false;
    }
    deleteRaw(reportId) {
        return this.http.delete(this.buildUrl(String(reportId)));
    }
}
BudgetReportService.DEFAULT_SERVICE_PATH = 'budgets';
//# sourceMappingURL=BudgetReportService.js.map